import React from 'react';
import Icon from '../../Icon';
import clsx from 'clsx';
import { Tooltip as ReactTooltip } from 'react-tooltip'; // Correct import for v5.x
import { translate } from '../../../Services/translation';

const HeaderButton = ({
  icon,
  quantityIcon,
  label,
  onClick,
  className,
  hideOnMobile,
  hideOnDesktop,
  renderAsLink,
  linkUrl,
  disabled
}) => {
  const buttonContent = (
    <>
      {icon && <Icon size={24} name={icon} className={clsx('header__button-icon', disabled && 'header__button-icon--disabled')} />}
      {label && <span className="header__button-text">{label}</span>}
      {quantityIcon && quantityIcon > 0 && (
        <div className="header__button-quantity-icon">
          {quantityIcon > 100 ? '99+' : quantityIcon}
        </div>
      )}
    </>
  );

  const commonProps = {
    id: 'header-button-tooltip',
    className: clsx(
      'header__button',
      hideOnMobile && 'header__button--mobile-none',
      hideOnDesktop && 'header__button--desktop-none',
      className && className
    ),
    'data-tooltip-content': disabled ? translate('general.coming-soon') : '', 
    disabled: disabled,
    onClick: !disabled ? onClick : undefined
  };

  return (
    <>
      {renderAsLink ? (
        <a
          href={linkUrl}
          {...commonProps}
        >
          {buttonContent}
        </a>
      ) : (
        <button
          {...commonProps}
        >
          {buttonContent}
        </button>
      )}

      <ReactTooltip anchorId="header-button-tooltip" effect="solid" delayShow={250} place="top" />
    </>
  );
};

export default HeaderButton;
